import React, { useState } from "react";
import { getLoggedInUserName } from "../../apis/sessionUtil";
export function ChangePassword() {
  // console.log(getLoggedInUserName());
  // var userName = "maheshhbhat@gmail.com";
  var userName = getLoggedInUserName();
  const [newPassword, setNewPassword] = useState("");
  const [newRePassword, setNewRePassword] = useState("");

  function onSubmit(){

  }
  
  return (
  
          <form onSubmit={onSubmit}>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  disabled
                  value={userName}
                  className="ipc"
                  name="userName"
                />
                <input
                  type="password"
                  value={newPassword}
                  className="ipt ipc"
                  onChange={(event) => setNewPassword(event.target.value)}
                  placeholder="Enter new Password "
                  name="newpassword"
                  required
                />
                <input
                  type="password"
                  value={newRePassword}
                  className="ipt ipc"
                  onChange={(event) => setNewRePassword(event.target.value)}
                  placeholder="Enter new Password again"
                  name="newpassword"
                  required
                />
              </div>
            </div>
            
            <div className="row">
              
              <div className="col">
                <button type="submit" className="ips ipc">
                  Change Password
                </button>
              </div>
            </div>
      
           
          </form>
       
  );
}
